import config from '@/config'
import { createAuthenticatedFetch } from '@/helpers/api/httpClient'

const apiFetch = createAuthenticatedFetch()

export interface LicenseDeviceResponse {
	activationId: number
	machineName?: string
	macAddress?: string
	osVersion?: string
	appVersion?: string
	activatedAt: string
	lastSeenAt?: string
	isActive: boolean
}

export const licenseDeviceApi = {
	list: async () => {
		const res = await apiFetch(`${config.API_URL}/api/subscription/license/devices`)
		if (!res.ok) {
			const err = await res.json().catch(() => ({}))
			return Promise.reject(err)
		}
		return res.json() as Promise<LicenseDeviceResponse[]>
	},

	deactivate: async (activationId: number) => {
		const res = await apiFetch(`${config.API_URL}/api/subscription/license/devices/${activationId}/deactivate`, {
			method: 'POST',
		})
		if (!res.ok) {
			const err = await res.json().catch(() => ({}))
			return Promise.reject(err)
		}
		return res.text()
	},
}
